import STATIC_ROUTES from '@data/staticRoutes.json';

export const updateRoomParamInUrl = (itemUrl: string): string => {
  const url = new URL(itemUrl ?? '', window.location.origin);
  const roomParams = url.searchParams.getAll('room');
  if (roomParams.length > 0) {
    const updatedRoomParams = roomParams
      .map((param) => param.replace(/,/g, '_'))
      .join(',');
    url.searchParams.delete('room');
    url.searchParams.append('room', updatedRoomParams);
  }
  return `${STATIC_ROUTES.hotelPathPrefix}${url
    .toString()
    .replace(window.location.origin, '')}`;
};
